export const broadcastBreadcrumb= t=> [
  { value: t("COMMON:FIELD.DATA_PROCESS"), to: "/" },
];
